import { useState } from 'react';
import { useTaskStatus } from './use-task-status';
const POLL_INTERVAL = 1000;
export function useCopyAssetTaskStatus(options = {}) {
  const [completedTask, setCompletedTask] = useState(null);
  const taskStatusQuery = useTaskStatus(Object.assign({}, options, {
    skip: true,
    notifyOnNetworkStatusChange: true,
    onCompleted: ({
      taskStatus
    }) => {
      if (taskStatus.status === 'COMPLETE') {
        var _options$onCompleted;
        setCompletedTask(taskStatus.tasks[0]);
        taskStatusQuery.stopPolling();
        options === null || options === void 0 || (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 || _options$onCompleted.call(options, {
          taskStatus
        });
      } else {
        taskStatusQuery.startPolling(POLL_INTERVAL);
      }
    }
  }));
  return Object.assign({
    completedTask
  }, taskStatusQuery);
}